"use client";
import { useCourseStore } from "@/lib/zustand/store/store";
import { useEffect } from "react";
import CourseContent from "./components/course-content";
import { CourseDetailsLg } from "./components/course-details-lg";
import CourseDetailsSm from "./components/course-details-sm";
import { useSession } from "next-auth/react";

type CourseDetailsProps = {
   courseSlug: string;
};

export const CourseDetails = ({ courseSlug }: CourseDetailsProps) => {
   const { playList, error, loading, fetchPlayList } = useCourseStore((state) => state);
   const { data }: any = useSession();

   useEffect(() => {
      fetchPlayList(courseSlug);
   }, [data]);

   if (error) {
      return <div>Something went wrong.. please try again..</div>;
   }

   return (
      <div className="md:w-3/4 lg:w-full mx-auto">
         <CourseDetailsSm className={"block lg:hidden"} courseDetails={playList} />
         <CourseDetailsLg className="hidden lg:flex" courseDetails={playList} />
         {/* {loading ? <div>Loading...</div> : <CourseContent />} */}
         <CourseContent />
      </div>
   );
};
